import { useContext } from 'react';
import ModelsContext from '@/lib/contexts/ModelsContext';
import type ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import { Tooltip } from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import PortfolioItemContext from '../../../../portfolio-item/PortfolioItemContext';
import InfoWrapper from './InfoWrapper';
import { FormattedMessage, useIntl } from 'react-intl';

type ModelInfoProps = {
  variant: ModelType;
};

const ModelInfo = ({ variant }: ModelInfoProps) => {
  const intl = useIntl();

  const models = useContext(ModelsContext);
  const { portfolioItem } = useContext(PortfolioItemContext);

  if (portfolioItem.modelId === null) {
    return null;
  }

  const model = models[variant][portfolioItem.modelId];

  if (typeof model === 'undefined' || model.isDefault) {
    return null;
  }

  const modelNameFallback = intl.formatMessage({
    id: 'portfolio.create_portfolio_item.model_select.options.name_fallback',
  });
  const modelName = model.name ?? modelNameFallback;

  return (
    <InfoWrapper>
      <InfoIcon />
      <FormattedMessage id="portfolio.challenge.options.model_info.model_name" />
      {modelName.length > 15 ? (
        <Tooltip title={modelName}>
          <span>{modelName}</span>
        </Tooltip>
      ) : (
        <span>{modelName}</span>
      )}
    </InfoWrapper>
  );
};

export default ModelInfo;
